import { GatsbyImage } from "gatsby-plugin-image"
import React, { useState } from "react"
import { useTransition } from "react-spring"
import getGatsbyImage from "utils/getGatsbyImage"
import useInterval from "../../../hooks/useInterval"
import {
  Dot,
  Quote,
  QuoteContent,
  QuoteImage,
  Quotes,
  Selector,
  Space,
  Wrapper,
} from "./index.styles"

interface IProps {
  quotes?: { id: string; text: string; author: string; image?: any }[]
  backgroundImage: any
}

const QuotesCarousel = (props: IProps) => {
  const [selected, setSelected] = useState(0)
  const quotes = props.quotes || []

  useInterval(() => {
    setSelected(selected => (selected + 1) % quotes.length)
  }, 8000)

  const transitions = useTransition(quotes[selected], {
    from: { x: typeof window !== "undefined" ? window.innerWidth : 0 },
    enter: { x: 0 },
    leave: { x: typeof window !== "undefined" ? -window.innerWidth : 0 },
  })

  return (
    <Wrapper>
      {props.backgroundImage ? (
        <GatsbyImage
          image={getGatsbyImage(props.backgroundImage.localFile)}
          alt=""
        />
      ) : (
        <div />
      )}
      <Quotes>
        {transitions(
          (props, item) =>
            item && (
              <Quote
                key={item.id}
                style={{
                  ...props,
                }}
              >
                {item.image && (
                  <QuoteImage>
                    <GatsbyImage
                      image={getGatsbyImage(item.image.localFile)}
                      alt={item.author}
                    />
                  </QuoteImage>
                )}
                <QuoteContent>
                  <div>{item.text}</div>
                  <div>{item.author}</div>
                </QuoteContent>
              </Quote>
            )
        )}
        <Space>
          {quotes[selected].image && (
            <QuoteImage>
              <GatsbyImage
                image={getGatsbyImage(quotes[selected].image.localFile)}
                alt={quotes[selected].author}
              />
            </QuoteImage>
          )}
          <QuoteContent>
            <div>“{quotes[selected].text}”</div>
            <div>{quotes[selected].author}</div>
          </QuoteContent>
        </Space>
      </Quotes>
      <Selector>
        {quotes.map((_, i) => (
          <Dot
            key={`dot-${i}`}
            selected={selected === i}
            onClick={() => setSelected(i)}
          />
        ))}
      </Selector>
    </Wrapper>
  )
}

QuotesCarousel.defaultProps = {
  quotes: [],
}

export default QuotesCarousel
